import React from "react";
import { useNavigate } from "react-router-dom";

type PropsType = {
  result?: any;
};

const HospitalTableRow = ({ result }: PropsType) => {
  const navigate = useNavigate();

  const reportDownloadHandler = (id: any) => {
    navigate(`/parent-test-result`, { state: result });
  };

  const hospitalNames = () => {
    let hospitals = result.kitId.careTeams.map((team: any) => {
      return team.hospitalName;
    });
    return hospitals.toString();
  };
  return (
    <>
      <hr className="tw-w-[90%] tw-mt-2 tw-mb-2" />
      <div className="tw-flex tw-items-center tw-justify-between tw-pb-2">
        <div className="tw-flex-1 tw-text-lg tw-text-[#000000] tw-font-normal">
          {result.userId.fullName}
        </div>
        <div className="tw-flex-1 tw-text-xl  tw-text-[#000000] tw-font-normal">
          {result?.petId?.petName}
        </div>
        <div className="tw-flex-1 tw-text-xl tw-text-[#000000] tw-font-normal">
          {result.riskLevel}
        </div>
        <div className="tw-flex-1 tw-text-xl tw-text-[#000000] tw-font-normal">
          {result.riskValue}
        </div>
        <div className="tw-flex-1 tw-text-xl tw-text-[#000000] tw-font-normal">
          {hospitalNames()}
        </div>

        <div className="tw-flex tw-flex-1">
          <button
            className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md"
            onClick={() => reportDownloadHandler(1)}
          >
            Download
          </button>
        </div>
      </div>
    </>
  );
};

export default HospitalTableRow;
